import useWorkflowSteps from '~/containers/viewer/explorer-sidebar/WorkflowStepper/useWorkflowSteps';

export function useLandmarkVisibility(): boolean {
    const { workingStep } = useWorkflowSteps();
    return workingStep?.id === 'registration';
}
